export default __webpack_public_path__ + "static/ventilator_b.7fe7869e037425b48fb7b6408e6ca90a.png";